"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reactstrap_1 = require("reactstrap");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
exports.Deployment = ({ data }) => {
    const { environment, successful, version, createdAt, creatingUser, template, } = data;
    const d = moment_1.default(createdAt);
    return (react_1.default.createElement(reactstrap_1.Row, null,
        react_1.default.createElement(reactstrap_1.Col, { className: "flex-grow-0" },
            react_1.default.createElement("h3", { className: successful ? 'text-success' : 'text-danger' },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: successful ? pro_solid_svg_icons_1.faCheckCircle : pro_solid_svg_icons_1.faExclamationTriangle }))),
        react_1.default.createElement(reactstrap_1.Col, null,
            react_1.default.createElement("div", { className: "mb-2" },
                react_1.default.createElement("h4", { className: "d-inline" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: `/templates/${template.id}/versions/${version.id}` }, version.version),
                    successful ? ' deployed to ' : ' failed to deploy to ',
                    react_1.default.createElement(react_router_dom_1.Link, { to: `/templates/${template.id}/${environment}` }, environment)),
                react_1.default.createElement("p", { className: "lead ml-2 d-inline" }, d.fromNow())),
            react_1.default.createElement(reactstrap_1.Row, null,
                react_1.default.createElement(reactstrap_1.Col, { className: "flex-shrink-0" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faUser, className: "mr-1" }),
                    " Deployed by",
                    ' ',
                    react_1.default.createElement(react_router_dom_1.Link, { to: `/admin/users/${creatingUser.id}` }, creatingUser.fullName || creatingUser.email)),
                react_1.default.createElement(reactstrap_1.Col, { className: "flex-shrink-0" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCalendar, className: "mr-1 ml-3" }),
                    ' ',
                    d.format('llll'))))));
};
//# sourceMappingURL=Deployment.js.map